module.exports = __webpack_public_path__ + "img/8_67.a7dcf977.png";